var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Wave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 480,
    viewBox: "0 0 1440 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.1328L27 32.2834C53 43.1591 107 63.4605 160 58.3851C213 53.3098 267 22.1328 320 11.2571C373 1.10641 427 11.2571 480 27.2081C533 43.1591 587 63.4605 640 79.4115C693 95.3625 747 105.513 800 79.4115C853 53.3098 907 -9.04425 960 1.10641C1013 11.2571 1067 95.3625 1120 110.589C1173 126.54 1227 74.3362 1280 63.4605C1333 53.3098 1387 84.4868 1413 100.438L1440 115.664V480H1413C1387 480 1333 480 1280 480C1227 480 1173 480 1120 480C1067 480 1013 480 960 480C907 480 853 480 800 480C747 480 693 480 640 480C587 480 533 480 480 480C427 480 373 480 320 480C267 480 213 480 160 480C107 480 53 480 27 480H0V22.1328Z",
    fill: "url(#paint0_linear_611_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_8",
    x1: 720,
    y1: 480,
    x2: 720,
    y2: 0.0187476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00264D",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Wave);
export default __webpack_public_path__ + "static/media/4wave.a511cffb166827e15ce8c1cd4bb78361.svg";
export { ForwardRef as ReactComponent };